import { WindowGoogleRecaptcha } from '../types/google-recaptcha'

export class GoogleRecaptchaService {
  private static instances: Map<string, Promise<WindowGoogleRecaptcha>> =
    new Map()

  static load(v3Sitekey?: string): Promise<WindowGoogleRecaptcha> {
    const existingPromise = this.instances.get(v3Sitekey || '')
    if (existingPromise) {
      return existingPromise
    }

    const loadingPromise = new Promise<WindowGoogleRecaptcha>(
      (resolve, reject) => {
        const script = document.createElement('script')
        script.src = `https://www.google.com/recaptcha/api.js${v3Sitekey ? `?render=${encodeURIComponent(v3Sitekey)}` : ''}`
        script.async = true
        script.defer = true
        script.onload = () => {
          const grecaptcha = window.grecaptcha
          if (!grecaptcha) {
            reject(
              new Error(
                'reCAPTCHA script loaded but window.grecaptcha is not defined',
              ),
            )
          } else {
            grecaptcha.ready(() => {
              resolve(grecaptcha)
            })
          }
        }
        script.onerror = error => {
          console.error('Error loading reCAPTCHA script', error)
          reject(error)
        }
        document.head.appendChild(script)
      },
    )

    this.instances.set(v3Sitekey || '', loadingPromise)
    return loadingPromise
  }
}
